<template>
  <luma-empty>
    <b-container class="main">
      <luma-single-vserver></luma-single-vserver>
      <luma-tabs-vserver></luma-tabs-vserver>
    </b-container>
  </luma-empty>
</template>

<script>
    import Vserver from "@/store/models/vserver/vserver"
    import LumaSingleVserver from "@/components/datacenter/vserver_datacenter/luma-single-vserver"
    import LumaTabsVserver from "@/components/datacenter/vserver_datacenter/luma-tabs-vserver"
    import LumaEmpty from "../../../layout/LumaEmpty";

    export default {
        name: "datacenter-vserver-single",
        data: () => ({
            timer:null
        }),
        components: {
          LumaEmpty,
          LumaTabsVserver,
          LumaSingleVserver
        },
        computed: {
            id() {
                return this.$route.params.id
            },
            vserver() {
                return Vserver.find(this.id)
            }
        },
        methods: {
            async fetchVserver() {
                await Vserver.fetch(this.id)
            }
        },
        mounted() {
            this.fetchVserver()
        },
        created() {
            Vserver.fetchStatus(this.id)
        }
    }
</script>

<style scoped>
  .main{
    min-width: 900px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/datacenter-vserver-single.vue